/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createMyUserPin } from '../fn/user-pin/create-my-user-pin';
import { CreateMyUserPin$Params } from '../fn/user-pin/create-my-user-pin';
import { deleteMyUserPin } from '../fn/user-pin/delete-my-user-pin';
import { DeleteMyUserPin$Params } from '../fn/user-pin/delete-my-user-pin';
import { getMyUserPin } from '../fn/user-pin/get-my-user-pin';
import { GetMyUserPin$Params } from '../fn/user-pin/get-my-user-pin';
import { listMyUserPins } from '../fn/user-pin/list-my-user-pins';
import { ListMyUserPins$Params } from '../fn/user-pin/list-my-user-pins';
import { UserPinDto } from '../models/user-pin-dto';

@Injectable({ providedIn: 'root' })
export class GeneratedUserPinService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listMyUserPins()` */
  static readonly ListMyUserPinsPath = '/api/user-pins/my';

  /**
   * Lists all pins of the currently signed in user, without the actual salt.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listMyUserPins()` instead.
   *
   * This method doesn't expect any request body.
   */
  listMyUserPins$Response(params?: ListMyUserPins$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserPinDto>>> {
    return listMyUserPins(this.http, this.rootUrl, params, context);
  }

  /**
   * Lists all pins of the currently signed in user, without the actual salt.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listMyUserPins$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listMyUserPins(params?: ListMyUserPins$Params, context?: HttpContext): Observable<Array<UserPinDto>> {
    return this.listMyUserPins$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UserPinDto>>): Array<UserPinDto> => r.body)
    );
  }

  /** Path part for operation `createMyUserPin()` */
  static readonly CreateMyUserPinPath = '/api/user-pins/my';

  /**
   * Creates a new pin salt for the currently signed in user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createMyUserPin()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createMyUserPin$Response(params?: CreateMyUserPin$Params, context?: HttpContext): Observable<StrictHttpResponse<UserPinDto>> {
    return createMyUserPin(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a new pin salt for the currently signed in user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createMyUserPin$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createMyUserPin(params?: CreateMyUserPin$Params, context?: HttpContext): Observable<UserPinDto> {
    return this.createMyUserPin$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserPinDto>): UserPinDto => r.body)
    );
  }

  /** Path part for operation `getMyUserPin()` */
  static readonly GetMyUserPinPath = '/api/user-pins/my/{id}';

  /**
   * Gets the salt of a specific pin of the currently signed in user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMyUserPin()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMyUserPin$Response(params: GetMyUserPin$Params, context?: HttpContext): Observable<StrictHttpResponse<UserPinDto>> {
    return getMyUserPin(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the salt of a specific pin of the currently signed in user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMyUserPin$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMyUserPin(params: GetMyUserPin$Params, context?: HttpContext): Observable<UserPinDto> {
    return this.getMyUserPin$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserPinDto>): UserPinDto => r.body)
    );
  }

  /** Path part for operation `deleteMyUserPin()` */
  static readonly DeleteMyUserPinPath = '/api/user-pins/my/{id}';

  /**
   * Deletes a specific pin of the currently signed in user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteMyUserPin()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteMyUserPin$Response(params: DeleteMyUserPin$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteMyUserPin(this.http, this.rootUrl, params, context);
  }

  /**
   * Deletes a specific pin of the currently signed in user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteMyUserPin$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteMyUserPin(params: DeleteMyUserPin$Params, context?: HttpContext): Observable<void> {
    return this.deleteMyUserPin$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
